export default "__VITE_ASSET__DvTPTwQZ__"